import { useMutation } from '@tanstack/react-query';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../lib/axios';
import { NewUnverifiedTravellerRequest } from '../types';
import { SelectOption } from '@invara-dev/react-base';

type mutationData = {
  companyId: number;
  model: NewUnverifiedTravellerRequest;
  activityId?: number;
};
export function useTravellerNameCheckMutation() {
  return useMutation({
    mutationFn: async ({ companyId, model, activityId }: mutationData) =>
      (
        await getAxios().post<TravellerNameCheckResponse[]>(
          ActivityEndpoints.travellers.checkName(companyId, activityId),
          model
        )
      ).data
  });
}

export type TravellerNameCheckResponse =
  | {
      Message: string;
      Options: SelectOption[];
      IsError: boolean;
    }
  | null
  | undefined;
